<template>
  <VTextField
    ref="df-text-field"
    v-model="model"
    class="df-text-field"
    :hint="schema.hint"
    :label="schema.label"
    :mask="schema.mask"
    :maxlength="schema.maxLength"
    :persistent-hint="true"
    :rules="rules"
    :type="inputType"
  />
</template>

<script>
/**
 * Original Author: Aaron Turnblom
 * Original Team: Area 51
 */
import { VTextField } from 'vuetify/lib';
import { PropsMixin, RulesMixin } from '../mixins';

export default {
  name: 'DfTextField',
  components: {
    VTextField,
  },
  mixins: [PropsMixin, RulesMixin],
  props: {
    /**
     * Field value
     * @type {object}
     */
    value: {
      type: [Number, String],
      default: '',
    },
  },
  data() {
    return {
      model: this.value || this.schema.value,
    };
  },
  computed: {
    inputType() {
      switch (this.schema.type) {
        case 'email':
          return 'email';
        case 'number':
          return 'number';
        case 'string':
          return 'text';
        default:
          return 'text';
      }
    },
    cleanedValue() {
      const model = this.model;
      if (this.schema.type === 'number') {
        return Number(model);
      }
      return this.model;
    },
  },
  watch: {
    value(newValue) {
      this.model = newValue;
    },
    // watch cleanedValue instead of model so that this
    // gets fired if either schema.type OR model changes
    cleanedValue(value) {
      this.$emit('input', value);
    },
  },
};
</script>

<style lang="scss" scoped>
@use "sass:map";
@use "~@nuskin/ns-core-styles/src/scss/colors";

$color-error: map.get(colors.$baseColors, 'color-error');

.df-text-field {
  flex: 1;

  ::v-deep .v-text-field__slot {
    flex-direction: column;
  }
}

.error--text ::v-deep {
  .df-text-field label {
    caret-color: $color-error !important;
    color: $color-error !important;
  }
}
</style>
